import { useState, type FormEvent } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { post } from '../api';
import { ErrorBox } from '../components/ui';

/** Reached from an invitation or reset link: /set-password?token=… */
export function SetPasswordPage() {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get('token') ?? '';
  const [password, setPassword] = useState('');
  const [again, setAgain] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [done, setDone] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    if (password !== again) {
      setError(new Error('Adgangskoderne er ikke ens'));
      return;
    }
    try {
      await post('/auth/set-password', { token, password });
      setDone(true);
      setTimeout(() => void navigate({ to: '/login' }), 1500);
    } catch (err) {
      setError(err);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <form onSubmit={submit} className="card w-full max-w-sm space-y-3">
        <h1 className="text-lg font-semibold">Vælg adgangskode</h1>
        <ErrorBox error={error} />
        {done ? (
          <p className="text-sm text-green-700">Adgangskoden er gemt. Du sendes til login…</p>
        ) : (
          <>
            <div>
              <label className="label">Ny adgangskode (mindst 12 tegn)</label>
              <input className="input" type="password" autoComplete="new-password" minLength={12} value={password} onChange={(e) => setPassword(e.target.value)} required autoFocus />
            </div>
            <div>
              <label className="label">Gentag</label>
              <input className="input" type="password" autoComplete="new-password" value={again} onChange={(e) => setAgain(e.target.value)} required />
            </div>
            <button className="btn btn-primary w-full justify-center">Gem</button>
          </>
        )}
      </form>
    </div>
  );
}
